import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
import CustomTabBar from "components/TabNavigation/CustomTabBar";
import { MdOutlineAssessment } from "react-icons/md";
import DailyOpdRevenueReports from "./DailyOpdRevenueReports";
import OPDdiscountReports from "./OPDdiscountReports";
import RevenueSummaryReport from "pages/RevenueReports/RevenueSummaryReport";
import DetailrevenueReports from "pages/RevenueReports/DetailRevenueReports/DetailrevenueReports";
import OutstandingOpdReports from "./OutstandingOpdReports";

const OPDRevenueReportsMain = () => {
  const [activeTab, setActiveTab] = useState("Daily OPD Collection Report");

  useEffect(() => {
    const storedTab = sessionStorage.getItem("tab");
    const validTabs = [
      "Daily OPD Collection Report",
      "Outstanding Opd Reports",
      "OPD Discount Reports",
      "Detailed Revenue Report",
      "Revenue Summary Report",
      "Detailed Revenue Report"
    ];

    if (storedTab && validTabs.includes(storedTab)) {
      setActiveTab(storedTab);
    } else {
      setActiveTab("Daily OPD Collection Report");
      sessionStorage.setItem("tab", "Daily OPD Collection Report");
    }
  }, []);

  useEffect(() => {
    setActiveTab(
      sessionStorage.getItem("tab") == "Daily OPD Collection Report"
        ? "Daily OPD Collection Report"
        : sessionStorage.getItem("tab")
    );
  }, []);

  const tabs = [
    { label: "Daily OPD Collection Report", value: "Daily OPD Collection Report" },
    { label: "Outstanding Opd Reports", value: "Outstanding Opd Reports" },
    // { label: "OPD Discount Reports", value: "OPD Discount Reports" },
    { label: "Revenue Summary Report", value: "Revenue Summary Report" },
    { label: "Detailed Revenue Report", value: "Detailed Revenue Report" }
  ].filter(Boolean);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };


  const [doclist, setdoclist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storeddoclist = sessionStorage.getItem("docAccesslist");
    if (storeddoclist) {
      try {
        // Parsing the JSON string to an array of objects
        const parseddoclist = JSON.parse(storeddoclist);
        setdoclist(parseddoclist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const viewAccess = doclist.some(
    (item) => item.hospital_module_id == 24 && item.view
  );
  const addAccess = doclist.some(
    (item) => item.hospital_module_id == 24 && item.add
  );
  const updateAccess = doclist.some(
    (item) => item.hospital_module_id == 24 && item.update
  );

  return (
    <>
      {viewAccess ? (
        <div className="w-full flex flex-col ">
          <div className="page-header">
            <div className="page-header-left page-title">
              <MdOutlineAssessment className="page-logo" />
              <Text>
                OPD Revenue Reports
              </Text>
            </div>
          </div>

          <CustomTabBar
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabClick}
          />
          <div className="h-[80vh] overflow-scroll ">
            {activeTab === "Daily OPD Collection Report" && (
              <DailyOpdRevenueReports setActiveTab={activeTab} />
            )}
            {activeTab === "Outstanding Opd Reports" && (
              <OutstandingOpdReports />
            )}
            {/* {activeTab === "OPD Discount Reports" && (
              <OPDdiscountReports />
            )} */}
            {activeTab === "Revenue Summary Report" && (
              <RevenueSummaryReport />
            )}
            {activeTab === "Detailed Revenue Report" && (
              <DetailrevenueReports />
            )}

          </div>
        </div>
      ) : (
        <AccessRightCard />
      )}
    </>
  );
};

export default OPDRevenueReportsMain;
